"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AccountConversionController = /** @class */ (function () {
    function AccountConversionController(service) {
        this.service = service;
    }
    AccountConversionController.prototype.idToRs = function (accountId) {
        return this.service.idToRs(accountId);
    };
    AccountConversionController.prototype.passphraseToPublicKey = function (passphrase, toByteArray) {
        return toByteArray ? this.service.passphraseToPublicKeyBytes(passphrase)
            : this.service.passphraseToPublicKey(passphrase);
    };
    AccountConversionController.prototype.publicKeyToId = function (publicKey) {
        return this.service.publicKeyToId(publicKey);
    };
    AccountConversionController.prototype.publicKeyToRs = function (publicKey) {
        return this.service.publicKeyToRs(publicKey);
    };
    AccountConversionController.prototype.passphraseToId = function (passphrase) {
        return this.service.passphraseToId(passphrase);
    };
    AccountConversionController.prototype.passphraseToRs = function (passphrase) {
        return this.service.passphraseToRs(passphrase);
    };
    return AccountConversionController;
}());
exports.default = AccountConversionController;
